import React from "react";
import { Box, ListItemButton, Typography } from "@mui/material";
import { formatDisplayTime } from "../../utils/utilityFunctions";

/**
 * Presentational list item for a single notification.
 * Keeps styling consistent and reusable across lists.
 */
export default function NotificationListItem({ notification, onClick }) {
  const title = notification.title || notification.subject || "Notification";
  const message = notification.message || notification.description;
  const time = notification.created_at;
  const isRead = Boolean(notification.is_read);

  return (
    <ListItemButton
      onClick={onClick}
      sx={{
        py: 1.5,
        px: 3,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        "&:last-child": { border: 0 },
        alignItems: "flex-start",
        bgcolor: (theme) =>
          isRead
            ? theme.palette.background.paper
            : theme.palette.action.selected,
        "&:hover": {
          bgcolor: (theme) => theme.palette.action.hover,
        },
      }}
      role="button"
      aria-label={`Open notification: ${title}`}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2" fontWeight={700}>
          {title}
        </Typography>
        {message && (
          <Typography variant="body2" color="text.secondary">
            {message}
          </Typography>
        )}
        {time && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mt: 0.5 }}
          >
            {formatDisplayTime(time)}
          </Typography>
        )}
      </Box>
      {!isRead && (
        <Box
          sx={{
            width: 12,
            height: 12,
            minWidth: 12,
            minHeight: 12,
            bgcolor: (theme) => theme.palette.primary.main,
            borderRadius: "50%",
            ml: 2,
            alignSelf: "center",
          }}
          aria-label="Unread notification indicator"
        />
      )}
    </ListItemButton>
  );
}
